import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import {
  getSubCategoriasR as getSubCats,
  jsonDeserialize,
} from "../../API/request";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.css';
import { Navigation } from 'swiper';

const Slider = ({ title, articulos = [] }) => {
  const [selected, setSelected] = useState(null);
  const [subCategorias, setSubCategorias] = useState([]);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const selectedRef = useRef(selected);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const sortedArticulos = [...articulos].sort((a, b) => {
    const getKey = (nombre) => {
      const serieA = nombre.match(/^A(\d+)(\s+e-tron)?$/i);
      if (serieA) {
        return `1-A-${serieA[1].padStart(2, '0')}${serieA[2] ? '-etron' : ''}`;
      }

      const serieQ = nombre.match(/^Q(\d+)(\s+e-tron)?$/i);
      if (serieQ) {
        return `2-Q-${serieQ[1].padStart(2, '0')}${serieQ[2] ? '-etron' : ''}`;
      }

      if (nombre.toLowerCase().includes('e-tron')) {
        return `3-etron-${nombre}`;
      }

      return `4-${nombre}`;
    };

    return getKey(a.nombre).localeCompare(getKey(b.nombre));
  });

  useEffect(() => {
    selectedRef.current = selected;
  }, [selected]);

  const handleClick = async (item) => {
    if (selectedRef.current && selectedRef.current.idCategoria === item.idCategoria) {
      setSelected(null);
      setSubCategorias([]);
      return;
    }

    try {
      const res = await getSubCats(item.idCategoria);
      const subCats = jsonDeserialize(res.data.data).data;
      setSelected(item);
      setSubCategorias(subCats);
    } catch (error) {
      console.error("Error al cargar subcategorías", error);
    }
  };

  useEffect(() => {
    if (swiperInstance && prevRef.current && nextRef.current) {
      // Asigna Navegacion
      swiperInstance.params.navigation.prevEl = prevRef.current;
      swiperInstance.params.navigation.nextEl = nextRef.current;

      // Reinicia Navegacion Swiper
      swiperInstance.navigation.destroy();
      swiperInstance.navigation.init();
      swiperInstance.navigation.update();
    }
  }, [swiperInstance]);

  return (
    <div className="full-container">
      <div className="container-models">
        <h2>
          {title}
        </h2>
        <div className="container-slider-wrapper" style={{ display: "flex", alignItems: "center" }}>
          <button ref={prevRef} className="custom-prev" aria-label="Previous">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M15 18L9 12L15 6" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="container-slider">
            { articulos.length > 0 && (
                <Swiper
                  modules={[Navigation]}
                  navigation={{
                    prevEl: prevRef.current,
                    nextEl: nextRef.current,
                  }}
                  onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = prevRef.current;
                    swiper.params.navigation.nextEl = nextRef.current;
                  }}
                  onSwiper={setSwiperInstance}
                  slidesPerView={8}
                  slidesPerGroup={1}
                  spaceBetween={30}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      slidesPerGroup: 1,
                    },
                    500: {
                      slidesPerView: 2,
                      slidesPerGroup: 1,
                    },
                    830: {
                      slidesPerView: 4,
                      slidesPerGroup: 3,
                    },
                    1500: {
                      slidesPerView: 6,
                      slidesPerGroup: 5,
                    },
                    1800: {
                      slidesPerView: 8,
                      slidesPerGroup: 7,
                    },
                  }}
                >
                  {sortedArticulos.map((item) => (
                    <SwiperSlide key={item.idCategoria}>
                      <div
                        className={`model-card ${
                          selected?.idCategoria === item.idCategoria ? "active" : ""
                        }`}
                        onClick={() => handleClick(item)}
                      >
                        <span className="model-title">{item.nombre}</span>
                        <div className="imgCard">
                          <img
                            src={process.env.REACT_APP_IMAGE_PATH + item.img}
                            alt={item.nombre}
                          />
                        </div>
                        <button
                          className="model-button"
                          id="triggerButton"
                          data-testid={item.nombre.toLowerCase()}
                        >
                          <p className="model-count">
                            {item.contadorArticulos} Modelo
                            {item.contadorArticulos > 1 ? "s" : ""}
                          </p>
                          <svg
                            className={`arrow-icon ${
                              selected?.idCategoria === item.idCategoria ? "rotated" : ""
                            }`}
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 10L12.5 15.5 18 10"
                              stroke="#333"
                              strokeWidth="1"
                              fill="none"
                            />
                          </svg>
                        </button>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
            )}
          </div>
          <button ref={nextRef} className="custom-next" aria-label="Next">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M9 6L15 12L9 18" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      {selected && (
        <div className="sub-models-panel">
          {subCategorias.map((sub, idx) => (
            <div key={idx} className="sub-model-card">
              <h3 className="model-name">{sub.nombre}</h3>
              {sub.nombre.toLowerCase().includes("e-tron") && (
                <span className="model-badge">Eléctrico</span>
              )}
              <img src={process.env.REACT_APP_IMAGE_PATH + sub.img} alt={sub.nombre} />
              <div className="model-links">
                <Link to={`/Lifestyle/accesorios/list/${selected.idCategoria}/${sub.idCategoria}`}>
                  Conoce más
                </Link>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Slider;
